export default function Status() {
  return (
    <div className="flex flex-col w-screen h-screen items-center justify-center">
      <div className="relative -top-12">
        <img src="/logo-light.png" alt="logo" className="p-4 w-64" />
        <pre>Unable to find a session id</pre>
      </div>
    </div>
  );
}